require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-i-prefer-githubpages-to-wordpresscom.json") })
        }
      }, "path---blog-i-prefer-githubpages-to-wordpresscom");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-i-prefer-githubpages-to-wordpresscom!./.cache/json/blog-i-prefer-githubpages-to-wordpresscom.json
// module id = 265
// module chunks = 231608221292675